var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H19M5 22H19M6 2V6C6 9.31371 8.68629 12 12 12M18 22V18C18 14.6863 15.3137 12 12 12M12 12C8.68629 12 6 14.6863 6 18V22M12 12C15.3137 12 18 9.31371 18 6V2M15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6M9 19H15",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandclock);
export default __webpack_public_path__ + "static/media/sandclock.54647d8b45473b0b534d86cd50439bfd.svg";
export { ForwardRef as ReactComponent };